import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import LotteryBall from './LotteryBall';

/**
 * 已选号码预览组件
 */
function SelectedPreview({ redBalls, blueBall, betAmount = 10 }) {
  const isComplete = redBalls?.length === 6 && blueBall;

  return (
    <Paper
      elevation={2}
      sx={{
        p: 2,
        background: isComplete
          ? 'linear-gradient(135deg, #FFF8E1 0%, #FFECB3 100%)'
          : '#FFFFFF',
        border: isComplete ? '2px solid #FF9800' : '1px solid #E0E0E0'
      }}
    >
      <Typography variant="subtitle2" sx={{ mb: 1.5, color: '#666', fontWeight: 600 }}>
        您已选择的号码
      </Typography>

      <Box sx={{ mb: 1.5 }}>
        <Typography variant="caption" sx={{ display: 'block', mb: 0.5, color: '#E53935' }}>
          红球（{redBalls?.length || 0}/6）
        </Typography>
        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
          {redBalls?.length > 0 ? (
            redBalls.map(num => (
              <LotteryBall
                key={num}
                number={num}
                type="red"
                selected={true}
                size="small"
                disabled={true}
              />
            ))
          ) : (
            <Typography variant="caption" sx={{ color: '#999' }}>
              请选择6个红球
            </Typography>
          )}
        </Box>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Typography variant="caption" sx={{ display: 'block', mb: 0.5, color: '#1E88E5' }}>
          蓝球（{blueBall ? 1 : 0}/1）
        </Typography>
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          {blueBall ? (
            <LotteryBall
              number={blueBall}
              type="blue"
              selected={true}
              size="small"
              disabled={true}
            />
          ) : (
            <Typography variant="caption" sx={{ color: '#999' }}>
              请选择1个蓝球
            </Typography>
          )}
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pt: 1.5,
          borderTop: '1px dashed #E0E0E0'
        }}
      >
        <Typography variant="body2" sx={{ color: '#666' }}>
          注数：<strong>1</strong> 注
        </Typography>
        <Typography variant="body2" sx={{ color: '#E53935', fontWeight: 600 }}>
          {betAmount}积分
        </Typography>
      </Box>

      {!isComplete && (
        <Typography
          variant="caption"
          sx={{
            display: 'block',
            mt: 1,
            color: '#FF9800',
            textAlign: 'center'
          }}
        >
          请选满6个红球和1个蓝球
        </Typography>
      )}
    </Paper>
  );
}

export default React.memo(SelectedPreview);
